import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FormDocumentoComponent } from './form-emitir-documento/form-documento.component';
import { GeneratedDocumentsComponent } from "../../../../../GlobalComponents/generated-documents/generated-documents.component";
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentoGenerado } from './models/response-documento-generado';
import { DocumentosEmitidosService } from './documentos-emitidos.service';
import { MatMenuModule } from '@angular/material/menu';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'documentos-emitidos',
    templateUrl: 'documentos-emitidos.component.html',
    imports: [
    MatButtonModule, CommonModule,
    GeneratedDocumentsComponent,
    MatMenuModule,

    HasPermissionsDirective
]
})

export class DocumentosEmitidosComponent implements OnInit {
    uu_id:string
    documentosEmitidos$:Observable<DocumentoGenerado[]>
    @Output() abrirDrawer = new EventEmitter<any>();
    @Input() seccion: number

    constructor(
        public dialog: MatDialog, 
        private route:ActivatedRoute,
        private documentosEmitidosService:DocumentosEmitidosService
    ) { 
        this.documentosEmitidos$= this.documentosEmitidosService.documentosEmitidosList$
    }

    ngOnInit() {
        this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
     }

    agregarDocumento(esFicha:boolean){
        const dialog = this.dialog.open(FormDocumentoComponent, {
                    panelClass: ['w-full', 'md:w-5/12'],
                    maxHeight: 'calc(100vh - 4rem)',
                    disableClose:true,
                    data: {
                        seccion:this.seccion,
                        uu_id: this.uu_id,
                        esFicha:esFicha
                    }
                })
    }
    
}